import { render, staticRenderFns } from "./Stap4.vue?vue&type=template&id=52675c7a&"
import script from "./Stap4.vue?vue&type=script&lang=js&"
export * from "./Stap4.vue?vue&type=script&lang=js&"
import style0 from "./Stap4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports